<template>
  <div class="map-selector">
    
    <!-- 地图控制区域 -->
    <div class="map-controls">
      <!-- <div class="control-item">
        <label for="city-select">选择城市：</label>
        <select id="city-select" v-model="selectedCity" @change="changeCity">
          <option value="">请选择城市</option>
          <option value="北京">北京</option>
          <option value="上海">上海</option>
          <option value="广州">广州</option>
          <option value="深圳">深圳</option>
          <option value="杭州">杭州</option>
        </select>
      </div> -->
      
      <div class="control-item">
        <label for="address-search">搜索地址：</label>
        <input 
          id="address-search" 
          type="text" 
          v-model="searchAddress" 
          placeholder="请输入详细地址"
          @keyup.enter="handleSearch"
        />
        <button @click="handleSearch">搜索</button>
      </div>
    </div>
    
    <!-- 百度地图容器 -->
    <div class="map-container">
      <div id="baidu-map" ref="baiduMap"></div>
    </div>
    
    <!-- 已选位置信息 -->
    <div class="location-info" v-if="selectedLocation">
      <h4>已选位置：</h4>
      <p>地址：{{ selectedLocation.address }}</p>
      <p>坐标：{{ selectedLocation.lng.toFixed(6) }}, {{ selectedLocation.lat.toFixed(6) }}</p>
      <div class="confirm-buttons">
        <button class="confirm-btn" @click="confirmSelection">确认选择</button>
        <button class="confirm-btn confirm-btn-secondary" @click="confirmSelectionTwo">确认选择二</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Appmap', // 添加组件名称
  props: {
    // 可以接收外部传入的初始位置
    initialLocation: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      selectedCity: '', // 当前选择的城市
      searchAddress: '', // 搜索的地址
      map: null, // 百度地图实例
      marker: null, // 地图标记
      geocoder: null, // 地理编码器
      localSearch: null, // 本地搜索服务
      selectedLocation: null, // 选择的位置
      loading: false // 加载状态
    };
  },
  mounted() {
    // 初始化百度地图
    this.initBaiduMap();
    
    // 初始化时如果有初始位置，设置到选中位置
    if (this.initialLocation.address) {
      this.selectedLocation = this.initialLocation;
    }
  },
  beforeDestroy() {
    // 销毁地图实例，释放资源
    if (this.map) {
      this.map.clearOverlays();
      this.map = null;
    }
  },
  methods: {
    // 初始化百度地图
    initBaiduMap() {
      // 检查百度地图API是否已加载
      if (typeof BMapGL === 'undefined') {
        // 动态加载百度地图WebGL API（最新版本）
        const script = document.createElement('script');
        // 使用HTTPS确保在HTTPS环境下正常加载
        // 注意：需要在百度地图开放平台设置正确的Referer白名单
        // 建议添加：localhost:4398,127.0.0.1:4398,192.168.0.167:4398,zk.hljtugewuangluo.com
        script.src = 'https://api.map.baidu.com/api?v=1.0&type=webgl&ak=hqMcmC7WdbYBUxc89M7npIZ5hm3Mg5Kd&callback=initMap';
        script.type = 'text/javascript';
        script.crossOrigin = 'anonymous'; // 添加跨域设置
        document.head.appendChild(script);
        
        // 定义全局回调函数
        window.initMap = () => {
          this.createMap();
        };
        
        // 添加错误处理
        script.onerror = () => {
          console.error('百度地图API加载失败，请检查网络连接和AK配置');
          alert('地图加载失败，请稍后重试');
        };
      } else {
        this.createMap();
      }
    },
    
    // 创建地图实例
    createMap() {
      // 创建地图
      this.map = new BMapGL.Map(this.$refs.baiduMap);
      
      // 设置默认中心点（北京）
      const point = new BMapGL.Point(116.404, 39.915);
      this.map.centerAndZoom(point, 12);
      
      // 添加地图控件
      this.map.addControl(new BMapGL.NavigationControl()); // 缩放控件
      this.map.addControl(new BMapGL.ScaleControl()); // 比例尺控件
      this.map.addControl(new BMapGL.OverviewMapControl()); // 缩略图控件
      
      // 启用地图拖拽和滚轮缩放
      this.map.enableDragging();
      this.map.enableScrollWheelZoom();
      
      // 创建地理编码器
      this.geocoder = new BMapGL.Geocoder();
      
      // 创建本地搜索服务
      this.localSearch = new BMapGL.LocalSearch(this.map, {
        renderOptions: { map: this.map },
        onSearchComplete: this.onSearchComplete
      });
      
      // 添加地图点击事件
      this.map.addEventListener('click', this.handleMapClick);
      
      console.log('百度地图初始化完成');
    },
    
    // 城市选择变化
    changeCity() {
      if (this.selectedCity && this.map) {
        this.loading = true;
        // 设置地图中心点为选择的城市
        this.map.centerAndZoom(this.selectedCity, 12);
        this.loading = false;
        console.log('城市已切换为：', this.selectedCity);
      }
    },
    
    // 处理地址搜索
    handleSearch() {
      if (!this.searchAddress || !this.map) return;
      
      this.loading = true;
      // 使用百度地图本地搜索服务
      this.localSearch.search(this.searchAddress);
    },
    
    // 搜索完成回调
    onSearchComplete(results) {
      this.loading = false;
      if (this.localSearch.getStatus() === BMAP_STATUS_SUCCESS) {
        if (results.getCurrentNumPois() > 0) {
          // 获取第一个搜索结果
          const poi = results.getPoi(0);
          const point = poi.point;
          
          // 清除现有标记
          this.map.clearOverlays();
          
          // 创建新标记
          this.marker = new BMapGL.Marker(point);
          this.map.addOverlay(this.marker);
          this.map.centerAndZoom(point, 16);
          
          // 设置选中位置
          this.selectedLocation = {
            address: poi.address + poi.title,
            lng: point.lng,
            lat: point.lat
          };
          
          console.log('搜索到的地址：', this.selectedLocation);
        } else {
          alert('未找到相关地址信息');
        }
      } else {
        alert('搜索失败，请重试');
      }
    },
    
    // 处理地图点击
    handleMapClick(e) {
      const point = e.point;
      
      // 清除现有标记
      this.map.clearOverlays();
      
      // 创建新标记
      this.marker = new BMapGL.Marker(point);
      this.map.addOverlay(this.marker);
      
      // 逆地理编码获取地址
      this.geocoder.getLocation(point, (result) => {
        if (result) {
          // 设置选中位置
          this.selectedLocation = {
            address: result.address,
            lng: point.lng,
            lat: point.lat
          };
          
          console.log('选择的位置：', this.selectedLocation);
        }
      });
    },
    
    // 确认选择
    confirmSelection() {
      if (this.selectedLocation) {
        // 向父组件发送选择的位置信息
        this.$emit('location-selected', this.selectedLocation);
        console.log('已确认位置：', this.selectedLocation);
      }
    },
    
    // 确认选择二
    confirmSelectionTwo() {
      if (this.selectedLocation) {
        // 向父组件发送选择的位置信息（确认选择二）
        this.$emit('location-selected-two', this.selectedLocation);
        console.log('已确认位置（确认选择二）：', this.selectedLocation);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.map-selector {
  width: 800px;
  margin: 0 auto;
  padding: 20px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
}
.map-title {
  font-size: 20px;
  font-weight: bold;
  color: #333;
  margin-bottom: 20px;
  text-align: center;
}

.map-controls {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  margin-bottom: 20px;
  padding: 15px;
  background: #f5f7fa;
  border-radius: 6px;
}

.control-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.control-item label {
  font-size: 14px;
  color: #666;
  white-space: nowrap;
}

.control-item select,
.control-item input {
  padding: 8px 12px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  font-size: 14px;
  outline: none;
  transition: border-color 0.2s;
}

.control-item select:focus,
.control-item input:focus {
  border-color: #409eff;
}

.control-item button {
  padding: 8px 16px;
  background: #409eff;
  color: #fff;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.control-item button:hover {
  background: #66b1ff;
}

.map-container {
  width: 100%;
  height: 400px;
  margin-bottom: 20px;
  border-radius: 6px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

#baidu-map {
  width: 100%;
  height: 100%;
}

.location-info {
  padding: 15px;
  background: #f5f7fa;
  border-radius: 6px;
  border-left: 4px solid #409eff;
}

.location-info h4 {
  margin: 0 0 10px 0;
  font-size: 16px;
  color: #333;
}

.location-info p {
  margin: 5px 0;
  font-size: 14px;
  color: #666;
}

.confirm-buttons {
  margin-top: 15px;
  display: flex;
  gap: 10px;
}

.confirm-btn {
  padding: 10px 24px;
  background: #67c23a;
  color: #fff;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.confirm-btn:hover {
  background: #85ce61;
}

.confirm-btn-secondary {
  background: #409eff;
}

.confirm-btn-secondary:hover {
  background: #66b1ff;
}
</style>
